<template>
    <div :class="['side-bar-big', className]">
        <b-nav vertical>
            <div class="author">
                <figure>
                    <b-img fluid :src="image"></b-img>
                </figure>
                <h2>Thuy B. <br/>Nguyen</h2>
            </div>
            <b-nav-item href="#about"><b-icon icon="person-fill"></b-icon> About</b-nav-item>
            <b-nav-item href="#projects"><b-icon icon="layout-text-window-reverse"></b-icon> Projects</b-nav-item>
            <b-nav-item href="#skills"><b-icon icon="bar-chart-fill"></b-icon> Skills</b-nav-item>
            <b-nav-item href="#experience"><b-icon icon="graph-up"></b-icon> Experience</b-nav-item>
            <b-nav-item href="#education"><b-icon icon="book"></b-icon> Education</b-nav-item>
            <b-nav-item href="#hobbies"><b-icon icon="binoculars"></b-icon> Hobbies</b-nav-item>
            <b-nav-item href="#contact"><b-icon icon="mailbox2"></b-icon> Contact</b-nav-item>
            <b-nav-item href="/resume.pdf" target="_blank"><b-icon icon="printer-fill"></b-icon> Resume</b-nav-item>
        </b-nav>
    </div>
</template>

<script>
export default {
    name: 'side-bar-big',
    props: {
        className: String,
    },
    data () {
        return {
            image: require('../assets/resume/thuy.jpg'),
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../styles/components/SideBarBig.scss'
</style>
